import { render } from "./speakerDetector.vue?vue&type=template&id=039e6d2f&scoped=true"
import script from "./speakerDetector.vue?vue&type=script&lang=js"
export * from "./speakerDetector.vue?vue&type=script&lang=js"

import "./index.scss?vue&type=style&index=0&id=039e6d2f&lang=scss&scoped=true&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-039e6d2f"]])

export default __exports__